export default {
  WalletRefill: "WalletRefill",
  WalletHistory: "WalletHistory",
};
